import React, { Fragment } from 'react'
import { List, Icon, Popconfirm } from 'antd'

const SelectedList = ({ list, onDelete, onDeleteItem, onEditItem, editItemClicked, nameProp, type = ''}) => {

	const removeDeleteItem = async (item) => {
		await onDeleteItem(item);
		onDelete(item);
	}

	return (
		<Fragment>
			<h3 style={{ marginBottom: 10 }}>SELECTED {type.toUpperCase()}</h3>
			<List
				size="large"
				bordered
				dataSource={list}
				renderItem={item => (
					<List.Item
						actions={[
							item.id && onEditItem && <Icon style={{ color: 'blue', fontSize: 18 }} onClick={() => editItemClicked(item)} type="edit" />,
							<Icon style={{ color: 'red', fontSize: 18 }} onClick={() => onDelete(item)} type="close" />,
							<Popconfirm title="This will delete the cookie" okText="Ok" cancelText="Cancel" onConfirm={e => removeDeleteItem(item)}>
								{item.id && onDeleteItem && <Icon style={{ color: 'blue', fontSize: 18 }} type="delete"/>}
							</Popconfirm>
						]}
					>
						{item.name || item[nameProp]}
					</List.Item>
				)}
			/>
		</Fragment>
	)
}
export default SelectedList
